import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IAiAssistant } from 'modules/cms/seo/ai-assistant/interfaces';
import {
  IDescriptionAndGenerateSeoResponse,
  IDescriptionResponse,
  IGeneratePayload,
  IGenerateSeoResponse,
} from '../interfaces/IGenerate';

class AiGenerateService extends EntityApiService<IAiAssistant> {
  generateStartSeo = (): Promise<{ data: string }> => {
    return ApiClientService.post(this.getPath('/generate-start-seo'), {});
  };

  generateDescription = (payload: IGeneratePayload): Promise<{ data: IDescriptionResponse }> => {
    if (payload.description) {
      return ApiClientService.post(this.getPath('/generate-description'), payload);
    }

    throw new Error('description is required');
  };

  generateSeo = (payload: IGeneratePayload): Promise<{ data: IGenerateSeoResponse }> => {
    if (payload.description) {
      return ApiClientService.post(this.getPath('/generate-seo'), payload);
    }

    throw new Error('description is required');
  };

  generateDescriptionAndSeo = async (
    seo: IGeneratePayload,
    product: IGeneratePayload,
    check: {
      isProduct: boolean;
      isSeo: boolean;
    },
  ): Promise<IDescriptionAndGenerateSeoResponse> => {
    let descRes, seoRes;

    if (check.isProduct) {
      descRes = await this.generateDescription(product);
    }
    if (check.isSeo) {
      seoRes = await this.generateSeo(seo);
    }

    return {
      product: descRes?.data,
      seo: seoRes?.data,
    };
  };
}

export default new AiGenerateService('/ms-cms/api/ai');
